import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "d-flex align-items-center" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = { class: "d-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = { class: "d-flex align-items-center" };
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_9 = ["readonly"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_toggler = _resolveComponent("toggler");
    return (_openBlock(), _createElementBlock("table", {
        class: _normalizeClass(["table", { glow: _ctx.newStato == 'Standby' }])
    }, [
        _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.planimetriaNonScalabile,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.task.standByTask.planimetriaNonScalabile) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "Planimetria non scalabile", -1))
                    ])
                ]),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.mancanoIndicazioniDisposizione,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.task.standByTask.mancanoIndicazioniDisposizione) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[9] || (_cache[9] = _createElementVNode("span", null, "Mancano indicazioni disposizione", -1))
                    ])
                ]),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.mancanoDestinazioniDuso,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.task.standByTask.mancanoDestinazioniDuso) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Mancano destinazioni d'uso", -1))
                    ])
                ])
            ]),
            _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.planimetriaScansionataMale,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.task.standByTask.planimetriaScansionataMale) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Planimetria scansionata male", -1))
                    ])
                ]),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.mancaIlGiardino,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.task.standByTask.mancaIlGiardino) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[12] || (_cache[12] = _createElementVNode("span", null, "Manca il giardino", -1))
                    ])
                ]),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.mancanoFiniture,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.task.standByTask.mancanoFiniture) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "Mancano finiture", -1))
                    ])
                ]),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_toggler, {
                            class: "mr-1",
                            disabled: _ctx.newStato != 'Standby',
                            modelValue: _ctx.task.standByTask.altro,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.task.standByTask.altro) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Altro", -1))
                    ]),
                    (_ctx.task.standByTask.altro)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.task.standByTask.altroText) = $event)),
                                readonly: _ctx.newStato != 'Standby'
                            }, null, 8, _hoisted_9), [
                                [_vModelText, _ctx.task.standByTask.altroText]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ], 2));
}
